
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^7(40|87)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
